module.exports = __webpack_public_path__ + "img/zhuye.45b3c4b5.jpg";